import { CommonModule, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'card-contador',
    template: `
        <div class="w-full bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
            <div class="flex items-start justify-end"> 
                <mat-icon [svgIcon]="icono"></mat-icon>
            </div>
            <div class="mt-2 flex flex-col items-center">
                <div class="text-7xl font-bold leading-none tracking-tight sm:text-8xl" 
                    [ngClass]="colorText">
                    {{numero}}
                </div>
                <div class="truncate text-md md:text-lg font-medium leading-6 tracking-tight">
                    {{nombre}}
                </div>
            </div>
        </div>
    `,
    imports:[
        MatIconModule, CommonModule
    ]
})

export class CardContadorComponent implements OnInit {
    @Input() numero: number
    @Input() nombre: string
    @Input() icono: string
    @Input() colorText: string
    constructor() { }

    ngOnInit() { }
}